<template>
    <div class="px-1 col-1 d-flex justify-content-end align-items-center">
        <div
            dusk="save-data"
            @click="$emit('save-data')"
            class="cursor-pointer h-100 d-flex flex-column justify-content-center align-items-center"
        >
            <i v-if="saving" class="fa fa-spin fa-circle-o-notch text-primary"></i>
            <i v-else-if="!editTarget" class="fa fa-times-circle-o rot-45 text-primary"></i>
            <i v-else="" class="fa fa-save text-primary"></i>
            <span v-if="saving"
                ><em style="white-space: nowrap;" class="small text-primary">Saving...</em></span
            >
            <span v-else-if="!editTarget"
                ><em style="white-space: nowrap;" class="small text-primary">Add Data</em></span
            >
            <span v-else=""
                ><em style="white-space: nowrap;" class="small text-primary">Save</em></span
            >
        </div>
        <div
            v-if="editTarget"
            @click="$emit('edit-done')"
            class="ml-2 cursor-pointer h-100 d-flex flex-column justify-content-center align-items-center"
        >
            <i class="fa fa-times text-primary"></i>
            <span><em style="white-space: nowrap;" class="small text-primary">Cancel</em></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrackerNewDataActions",
    props: ["saving", "editTarget"],
};
</script>

<style scoped></style>
